import axios from 'axios'

const API_KEY    = process.env.VUE_APP_API_KEY
const apiBaseUrl = process.env.VUE_APP_API

export const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept':        'application/json',
  },
})

api.interceptors.request.use(config => {
  if (API_KEY) {
    config.headers['x-api-key'] = API_KEY
  }
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
}, error => Promise.reject(error))


// ─────────────────────────────────────────────────────────────────────────────
// AUTH JUECES
// ─────────────────────────────────────────────────────────────────────────────
export const login_jueces = async ({ email, password }) => {
  const response = await api.post('jueces/login/', { email, password })
  return response.data
}


// ─────────────────────────────────────────────────────────────────────────────
// TORNEO
// antes: torneos/activo/
// ahora: torneos/  → array, tomamos el primero (ViewSet filtra esta_activo=True)
// ─────────────────────────────────────────────────────────────────────────────
export const getTorneoActivo = async () => {
  try {
    const response = await api.get('torneos/')
    const data = response.data
    // Compatible con paginación DRF (results) y sin paginación (array directo)
    return data.results?.[0] ?? data[0] ?? null
  } catch (error) {
    console.error('Error fetching active torneo:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// PRECIOS
// antes: torneos/precio-inscripcion/
// ahora: torneos/{id}/precios/
// ─────────────────────────────────────────────────────────────────────────────
export const getPrecioInscripcion = async (torneoId) => {
  try {
    const response = await api.get(`torneos/${torneoId}/precios/`)
    return response.data
  } catch (error) {
    console.error('Error fetching precios:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// CATEGORÍAS DE PESO
// antes: torneos/categorias-peso/
// ahora: api/torneos/{id}/categorias/?modalidad=gi&genero=H
// ─────────────────────────────────────────────────────────────────────────────
export const getCategoriasPeso = async (torneoId, { modalidad, genero } = {}) => {
  try {
    const params = {}
    if (modalidad) params.modalidad = modalidad
    if (genero)    params.genero    = genero
    const response = await api.get(`torneos/${torneoId}/categorias/`, { params })
    return response.data
  } catch (error) {
    console.error('Error fetching categorías:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// PELEADORES
// antes: torneos/peleadores/estelares/ y torneos/{id}/peleadores/
// ahora: inscripciones/?torneo={id}
// ─────────────────────────────────────────────────────────────────────────────
export const getPeleadoresEstelares = async (genero = null) => {
  try {
    const params = {}
    if (genero) params.genero = genero
    const response = await api.get('peleadores/estelares/', { params })
    return Array.isArray(response.data)
      ? response.data
      : response.data?.results || []
  } catch (error) {
    console.error('Error fetching estelares:', error)
    throw error
  }
}

export const getPeleadorByEmail = async (email) => {
  try {
    const response = await api.get('peleadores/by-email/', { params: { email } })
    return response.data
  } catch (error) {
    if (error.response?.status === 404) return null  // no encontrado → flujo normal
    console.error('Error fetching peleador by email:', error)
    throw error
  }
}


export const getInscripcionesPorEmail = async (email) => {
  try {
    const response = await api.get('inscripciones/por-peleador/', { params: { email } })
    return response.data
  } catch (error) {
    console.error('Error fetching inscripciones:', error)
    throw error
  }
}


// ─────────────────────────────────────────────────────────────────────────────
// EVENTO EN VIVO
// nuevo — no existía en la versión anterior
// ─────────────────────────────────────────────────────────────────────────────
export const getTatamis = async (torneoId) => {
  try {
    const response = await api.get('tatamis/', { params: { torneo: torneoId } })
    return response.data
  } catch (error) {
    console.error('Error fetching tatamis:', error)
    throw error
  }
}

export const getPeleaActiva = async (tatamiId) => {
  try {
    const response = await api.get(`tatamis/${tatamiId}/pelea-activa/`)
    return response.data
  } catch (error) {
    if (error.response?.status === 404) return null
    console.error('Error fetching pelea activa:', error)
    throw error
  }
}

export const getProximasPeleas = async (tatamiId) => {
  try {
    const response = await api.get(`tatamis/${tatamiId}/proximas/`)
    return response.data
  } catch (error) {
    console.error('Error fetching próximas peleas:', error)
    throw error
  }
}

export const postContacto = async (payload) => {
  try {
    const response = await api.post('contacto/', payload)
    return response.data
  } catch (error) {
    console.error('Error en formulario de contacto:', error)
    throw error
  }
}

// ─────────────────────────────────────────────────────────────────────────────
// INSCRIPCIÓN — nuevo flujo
// Un solo endpoint recibe todo y crea el RegistroPendiente + PaymentIntent
// ─────────────────────────────────────────────────────────────────────────────
export const iniciarPagoInscripcion = async ({ torneoId, peleador, inscripcion, currency = 'mxn' }) => {
  try {
    const response = await api.post('inscripciones/pago/', {
      torneo_id: torneoId,
      currency,
      peleador,
      inscripcion,
    })
    return response.data  // { clientSecret, paymentIntentId, precio, moneda }
  } catch (error) {
    console.error('Error iniciando pago:', error)
    throw error
  }
}

export const subirFotoPeleador = async (email, fotoFile) => {
  try {
    const formData = new FormData()
    formData.append('email', email)
    formData.append('foto', fotoFile)
    
    const response = await api.post('peleadores/subir-foto/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  } catch (error) {
    console.error('Error subiendo foto:', error)
    console.error('Error response:', error?.response?.data)
    throw error
  }
}

export const verificarPagoInscripcion = async (paymentIntentId) => {
  try {
    const response = await api.get('inscripciones/verificar-pago/', {
      params: { payment_intent_id: paymentIntentId }
    })
    return response.data
  } catch (error) {
    console.error('Error verificando pago:', error)
    throw error
  }
}